import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IGuestStore} from './guest.stores';
import {IAppRootStore} from '../../app.root.store';
import {GuestView as GuestViewComponent} from '../../components/guest/views/view';

interface GuestViewProps {
    guestStore: IGuestStore;
    rootStore: IAppRootStore;
}

@observer
export class GuestViewComponentWrapper extends TechseeBaseComponent<GuestViewProps> {
    renderInternal(): JSX.Element {
        const {guestStore} = this.props;
        return <GuestViewComponent controller={guestStore.guestController} />;
    }
}

export const GuestView = inject('rootStore', 'guestStore')(GuestViewComponentWrapper) as IReactComponent;
